import React from "react";
import PropTypes from "prop-types";

function clampPercent(value) {
  return Math.min(100, Math.max(0, value));
}

const ScoreProgressBar = ({ scorePercent, passed, ariaLabel }) => {
  const boundedScore = clampPercent(scorePercent);
  const statusClass = passed ? "passed" : "failed";

  return (
    <div
      className={`th-agentforce-assessment__score-progress th-agentforce-assessment__score-progress--${statusClass}`}
      role="progressbar"
      aria-label={ariaLabel}
      aria-valuemin="0"
      aria-valuemax="100"
      aria-valuenow={boundedScore}>
      <div
        className="th-agentforce-assessment__score-progress-fill"
        style={{ width: `${boundedScore}%` }}
      />
    </div>
  );
};

ScoreProgressBar.propTypes = {
  scorePercent: PropTypes.number.isRequired,
  passed: PropTypes.bool.isRequired,
  ariaLabel: PropTypes.string.isRequired,
};

export default ScoreProgressBar;
